import { OnboardingStatus } from '../../enums';

export interface CorporateOnboardingRecordDto {
  id: string; // Guid
  corporationId: string; // Guid
  corporationName: string;
  contactName: string;
  contactEmail: string;
  contactPhone?: string | null;
  businessType: string;
  taxId?: string | null;
  status: OnboardingStatus;
  submittedAt: string; // DateTime as ISO string
  completedAt?: string | null; // DateTime as ISO string
  notes?: string | null;
  requiredDocuments?: string | null;
  submittedDocuments?: string | null;
  processedBy?: string | null; // Guid
  createdAt: string; // DateTime as ISO string
  updatedAt?: string | null; // DateTime as ISO string
}
